import { Link, useNavigate, useLocation } from "react-router-dom";
import { Phone, Mail, FileText, ArrowUp, Hash } from "lucide-react";
import { scrollToId } from "@/lib/api";

export const Footer = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const go = (href) => {
    if (href === "#top") window.__lenis ? scrollToId("#top") : window.scrollTo({ top: 0, behavior: "smooth" });
    else if (pathname === "/") scrollToId(href);
    else navigate("/" + href);
  };

  return (
  <footer id="contatti" className="pt-28 pb-12" data-testid="footer-section">
    <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
      <div className="grid lg:grid-cols-3 gap-16 pb-20 border-b border-white/10">
        <div>
          <img
            src="/logo-dark.png"
            alt="Star Edil srls"
            className="h-20 w-auto mb-8"
            data-testid="footer-logo"
          />
          <p className="font-display italic text-xl text-muted-foreground mb-4">Costruiamo il futuro, dalle fondamenta.</p>
          <p className="text-sm text-muted-foreground/70 leading-relaxed">
            Star Edil srls — Impresa edile specializzata in ristrutturazioni chiavi in mano.
          </p>
        </div>

        <div>
          <h3 className="font-oswald uppercase text-sm tracking-[0.3em] text-gold mb-8">Contatti</h3>
          <div className="flex flex-col gap-5 text-muted-foreground">
            <a href="tel:+393474532075" data-testid="footer-phone" className="flex items-center gap-4 hover:text-gold transition-colors duration-300 w-fit">
              <Phone className="w-4 h-4 text-gold shrink-0" /> +39 347 4532075
            </a>
            <a href="mailto:star.edil18@gmail.com" data-testid="footer-email" className="flex items-center gap-4 hover:text-gold transition-colors duration-300 w-fit">
              <Mail className="w-4 h-4 text-gold shrink-0" /> star.edil18@gmail.com
            </a>
            <div data-testid="footer-piva" className="flex items-center gap-4 w-fit">
              <Hash className="w-4 h-4 text-gold shrink-0" /> P. IVA 10426680962
            </div>
            <a href="mailto:fabio.tricomi@pec.it" data-testid="footer-pec" className="flex items-center gap-4 hover:text-gold transition-colors duration-300 w-fit">
              <FileText className="w-4 h-4 text-gold shrink-0" /> PEC: fabio.tricomi@pec.it
            </a>
          </div>
        </div>

        <div>
          <h3 className="font-oswald uppercase text-sm tracking-[0.3em] text-gold mb-8">Navigazione</h3>
          <div className="flex flex-col gap-4">
            {[
              ["Servizi", "#servizi"],
              ["Lavori", "#lavori"],
              ["Chi Siamo", "#chi-siamo"],
              ["Richiedi Preventivo", "#preventivo"],
            ].map(([label, href]) => (
              <button
                key={href}
                onClick={() => go(href)}
                data-testid={`footer-link-${label.toLowerCase().replace(/\s/g, "-")}`}
                className="text-left text-muted-foreground hover:text-gold transition-colors duration-300 font-oswald uppercase tracking-[0.15em] text-sm w-fit"
              >
                {label}
              </button>
            ))}
            <Link
              to="/clienti-soddisfatti"
              data-testid="footer-link-clienti"
              className="text-left text-muted-foreground hover:text-gold transition-colors duration-300 font-oswald uppercase tracking-[0.15em] text-sm w-fit"
            >
              Clienti Soddisfatti
            </Link>
            <Link
              to="/privacy"
              data-testid="footer-link-privacy"
              className="text-left text-muted-foreground hover:text-gold transition-colors duration-300 font-oswald uppercase tracking-[0.15em] text-sm w-fit"
            >
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>

      <div className="pt-10 flex flex-wrap items-center justify-between gap-6">
        <p className="text-xs text-muted-foreground/60 font-oswald uppercase tracking-[0.2em]">
          © 2018 Star Edil srls — Tutti i diritti riservati
        </p>
        <button
          onClick={() => go("#top")}
          data-testid="footer-back-to-top"
          className="flex items-center gap-3 text-xs text-muted-foreground hover:text-gold transition-colors duration-300 font-oswald uppercase tracking-[0.2em]"
        >
          Torna su <ArrowUp className="w-4 h-4 text-gold" />
        </button>
      </div>
    </div>
  </footer>
  );
};
